import { spaceService } from "@/services/space-service";
import { useCallback, useState } from "react";

type SearchSpace = {
  address: string;
  name: string;
  placeId: string;
};

export type { SearchSpace };

export function useSearchSpaces() {
  const [spaces, setSpaces] = useState<SearchSpace[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearchSpaces = useCallback(async (term: string) => {
    if (!term || term.length < 3) {
      setSpaces([]);
      return;
    }
    setIsLoading(true);
    try {
      const response = await spaceService.getSearchSpaces({
        term,
      });
      setSpaces(response);
    } catch (error) {
      console.error(error);
      setSpaces([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    spaces,
    handleSearchSpaces,
    isLoading,
  };
}
